





































































































import { vxm } from '../store.vuex';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { AuthParams } from '@/models/userdata/authparams';
import VueRecaptcha from 'vue-recaptcha';
import { Frictionless } from '../models/referrals/frictionless';
import { ReferralPayload } from '../models/referrals/referralPayload';
import { Referral } from '../models/referrals/referral';
import router from '../router';
import VueToastr from '@deveodk/vue-toastr';
import SsoLogin from './Registration/SsoLogin.vue';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
import { Job } from '@/models/jobs/job';
import GDPR from '@/components/Registration/GDPR.vue';
declare var window: any;

Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 3000,
});

@Component({
  name: 'JobShare',
  components: {
    VueRecaptcha,
    SsoLogin,
    GDPR,
  },
})
export default class JobShare extends Vue {
  private frictionLess: Frictionless = new Frictionless();
  private isNotARobot: boolean = false;
  private fullName: string = '';
  private email: string = ''; // email or phone
  private emailId: string = '';
  private phone: string = '';
  private errorString: string = '';
  private jobName: string = '';
  private gdprObj = { marketingEmailFlag: false, tosEmailFlag: false };
  $wlToastr: any;

  mounted() {
    const vm = this;
    if (vm.$route.query.fullName) {
      vm.fullName = vm.$route.query.fullName.toString();
    }
    if (vm.$route.query.email) {
      vm.email = vm.$route.query.email.toString();
    }
    Vue.cookies.remove('referralSuccess');
    Vue.cookies.remove('frictionLess');
  }
  get maxlengthEmailOrMobile() {
    return this.isNumber(this.email) ? '10' : '50';
  }

  get termsOfServiceURL() {
    return vxm.configs.getCompanyPreference(
      'CANDIDATE_PORTAL_TERMS_OF_SERVICE_END_POINT_URL',
      'termsLink',
    );
  }
  get privacyPolicyURL() {
    return vxm.configs.getCompanyPreference(
      'CANDIDATE_PORTAL_PRIVACY_POLICY_END_POINT_URL',
      'privacyLink',
    );
  }

  goTodetail() {
    const jobid = this.$route.params.JobID;
    vxm.jobs.setJobID(parseInt(jobid));
    localStorage.jobviewpage = true;
    this.$router.push({ name: 'Jobdetails', params: { JobID: jobid + '' } });
  }

  googleLogin() {
    this.setOAuthProvider('google');
    this.setReferringComponent('JobShare');
    return vxm.users.loginWithGoogle();
  }

  get CaptchaClientSiteKey() {
    return vxm.configs.getGlobalConfigValue('RECAPTCHA_CLIENT_SITE_KEY');
  }

  get selectedJobName() {
    let jobs: Job[] = vxm.jobs.Jobs;
    let jobid = this.$route.params.JobID;
    const jobId = parseInt(jobid);
    let Job: Job[] = jobs.filter((job) => job.jobPostingId === jobId);
    const jobFacilityLocation = Job && Job[0] ? Job[0].facility.name : '';
    //return vxm.referrals.getRefferedJob + ", " + jobFacilityLocation;
    return vxm.referrals.getRefferedJob;
  }

  @Watch('selectedJobName')
  onPropertyChanged(value: string, oldValue: string) {
    console.log(value, '**New Valuew');
    this.jobName = value;
  }

  facebookLogin() {
    this.setOAuthProvider('facebook');
    this.setReferringComponent('JobShare');
    return vxm.users.loginWithFacebook();
  }

  setReferringComponent(component: string) {
    this.$cookies.set('referringComponent', component);
  }

  setOAuthProvider(provider: string) {
    this.$cookies.set('OAuthProvider', provider, 300);
  }

  intiateFrictionlessReferral() {
    vxm.referrals.postFrictionlessReferral(this.frictionLess);
  }

  onCaptchaVerified(recaptchaToken) {
    vxm.referrals.getRecaptchaResponse(recaptchaToken);
  }

  goToInvite(evt) {
    if(evt && evt.preventDefault) evt.preventDefault();
    const vm = this;
    if (!vm.validateDataJobShareReferral()) {
      vm.$wlToastr('error', vm.$t(vm.errorString), 'Referral');
    } else {
      const referral = new Referral();
      referral.jobPostingId = parseInt(this.$route.params.JobID, 10);
      referral.userFullName = this.fullName;
      referral.email = this.emailId;
      referral.phoneNbr = this.phone;
      referral.referralCode = vxm.referrals.globalRefCode;
      referral.companyCode = vxm.jobs.BrandingInfo.companycode;
      console.log(referral);

      const respPromise: any = vxm.referrals.checkQuickSignupUserexist(
        referral,
      );

      Promise.all([respPromise]).then((values) => {
        console.log(values[0].success);
        if (!values[0].success) {
          if (values[0].errorCode === '90' || '20') {
            vm.$wlToastr(
              'info',
              this.$t('jobshare.already.registered.text'),
              this.$t('referral-label'),
            );
            this.setReferringComponent('Invite');
            this.$router.push('/login');
          } else {
            vxm.referrals.jobShareReferral(referral);
          }
        } else {
          vxm.referrals.jobShareReferral(referral);
        }
      });
    }
  }
  validateDataJobShareReferral(): boolean {
    const emailformat = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    const mobileNumberFormat = /^[0-9]{10}$/;
    const vm = this;
    if (vm.fullName) {
      vm.fullName = vm.fullName.trim();
    }
    if (vm.email) {
      vm.email = vm.email.trim();
    }
    if (!vm.fullName) {
      this.errorString = 'jobshare.fullname.required';
      return false;
    }

    if (!vm.email) {
      this.errorString = 'jobshare.email.required';
      return false;
    }

    if (!(vm.email.match(emailformat) || vm.email.match(mobileNumberFormat))) {
      this.errorString = 'jobshare.enter.valid.email.phone';
      return false;
    }

    if (vm.email.match(mobileNumberFormat)) {
      this.phone = `+1 ${this.email}`;
      this.emailId = '';
    } else {
      this.emailId = this.email;
      this.phone = '';
    }
    if (!vxm.referrals.RecaptchaResponse.success) {
      this.errorString = 'jobshare.enter.recaptcha.response';
      return false;
    }
    return true;
  }

  findJob() {
    router.push({ name: 'Findjobs' });
  }

  isNumber(value: string | number): boolean {
    return value != null && !isNaN(Number(value.toString()));
  }
  
  get isGDPREnabled () {
    return vxm.configs.getGlobalConfigValue('IS_GDPR_ENABLED');
  }
  
  gdpr(gdprObj: any) {
    this.gdprObj = gdprObj;
  }

  get isSubmittDisabled() {
    if (this.isGDPREnabled && (!this.gdprObj.tosEmailFlag  || !this.gdprObj.marketingEmailFlag) && !this.isLoggedIn) {
      return true;
    } else if (this.isGDPREnabled && (this.gdprObj.tosEmailFlag || this.gdprObj.marketingEmailFlag)) {
      false;
    }
    return false;
  }

  
  get UserTOSAgreementText() {
    const customTOStext = vxm.users.getUserLang == 'fr'  ? 
    vxm.configs.getGlobalConfigValue('USER_TOS_AGREEMENT_TEXT_FR') 
    :vxm.configs.getGlobalConfigValue('USER_TOS_AGREEMENT_TEXT');
    if (customTOStext) return customTOStext
      .replace(/{companyName}/g, vxm.utility.companyName)
      .replace(/{termsOfServiceURL}/g, this.termsOfServiceURL)
      .replace(/{privacyPolicyURL}/g, this.privacyPolicyURL);
    return this.$t('signup.terms.services', {
      termsOfServiceURL: this.termsOfServiceURL,
      privacyPolicyURL: this.privacyPolicyURL,
      companyName: vxm.utility.companyName
    })
  }
  
  get isLoggedIn(): boolean {
    return vxm.users.isLoggedIn;
  }

  
}
